import classNames from "classnames";
import styles from "./index.module.less";
import HBIcon from "../HBIcon";

/**
 * @param pinCount {number}
 * @param title {string}
 * @param coverUrl {string}
 * @param isPrivate {boolean | undefined}
 * @param onClick {() => void | undefined}
 * @param className {string | undefined}
 * @returns {JSX.Element}
 * @constructor
 */
export default function BoardItem({
  pinCount,
  title,
  coverUrl,

  isPrivate,
  onClick,
  className,
  limitByPinCount,
  limitByPrivate,
}) {
  const getLimit = () => {
    if (limitByPrivate && isPrivate) {
      return "不可选，私密画板内容无法审核";
    }
    if (limitByPinCount > 0 && pinCount < limitByPinCount) {
      return `不可选，画板内采集数不满${limitByPinCount}张`;
    }
    return null;
  };

  return (
    <div
      className={classNames([className, styles.boardItem])}
      onClick={onClick}
    >
      <div>
        <div className={styles.divImage}>
          {coverUrl ? (
            <img
              className={styles.cover}
              src={coverUrl}
              alt="封面"
              loading="lazy"
            />
          ) : (
            <div className={classNames(styles.cover, styles.coverEmpty)}>
              <HBIcon type="ic_logo" />
            </div>
          )}
          {getLimit() && <span className={styles.layer}></span>}
        </div>
        <div
          className={classNames(styles.boardName, {
            [styles.boardNameIsOnly]: getLimit(),
          })}
          title={title}
        >
          {title}
        </div>
        {!!isPrivate && (
          <>
            &nbsp;
            <HBIcon type="ic_lock" className={styles.privateIcon} />
          </>
        )}
      </div>
      <div>
        {getLimit() && <span className={styles.limit}>{getLimit()}</span>}
        {!getLimit() && <span className={styles.count}>{pinCount}</span>}
      </div>
    </div>
  );
}
